"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class MerchantPrinterApi {
    constructor(api) {
        this.api = api;
    }
    /**
     * 取得餐廳的 printerSetting
     */
    getPrinterSetting() {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/printersetting';
            const response = yield this.api.axiosNode.get(endpoint);
            return response.data;
        });
    }
    /**
     * 修改餐廳的 printerSetting
     */
    updatePrinterSetting(printerSetting) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/printersetting';
            const data = { data: JSON.stringify(printerSetting) };
            const response = yield this.api.axiosNode.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改堂食自動確認 (開啟/關閉)
     */
    updatePrinterAutoConfirm(enabled) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/autoconfirm';
            const data = { value: enabled };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改外賣提示音次數
     * count -1 表示無限次
     */
    updateTakeawayNotifyAudioPlayCount(count) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/takeawaynotifyaudioplaycount';
            const data = { value: count };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 修改外送提示音次數
     * count -1 表示無限次
     */
    updateStoreDeliveryNotifyAudioPlayCount(count) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchant/setting/storedeliverynotifyaudioplaycount';
            const data = { value: count };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
}
exports.default = MerchantPrinterApi;
//# sourceMappingURL=MerchantPrinter.js.map